export const SidebarLeftIcon = ({
  height = 24,
  width = 24,
  color = "#346fef",
  size = 24
}) => {
  return (
    <svg
      class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-vubbuv"
      focusable="false"
      aria-hidden="true"
      viewBox="0 0 24 24"
      color={color}
      height={height}
      width={width}
      fill={color}
      style={{ fontSize: size || height}}
      
    >
      <path d="M18.966 21.745H5.641a3.345 3.345 0 01-3.337-3.337V5.083c0-1.838 1.5-3.338 3.337-3.338H18.98c1.825 0 3.325 1.5 3.325 3.338V18.42c0 1.825-1.5 3.325-3.338 3.325zM5.641 3.408A1.67 1.67 0 003.98 5.07v13.338c0 .912.75 1.662 1.662 1.662H18.98a1.67 1.67 0 001.662-1.662V5.083A1.67 1.67 0 0018.98 3.42H5.64v-.012zm3.325 18.337c-.5 0-.837-.337-.837-.837V2.583c.012-.5.337-.838.837-.838.5 0 .838.338.838.838V20.92c0 .488-.338.825-.838.825zm5-9.162c-.25 0-.412-.088-.587-.25a.819.819 0 01.012-1.175l2.5-2.5c.338-.338.838-.338 1.163 0 .337.337.337.837 0 1.162l-2.5 2.5a.743.743 0 01-.588.263zm2.5 2.5c-.25 0-.412-.088-.587-.25l-2.5-2.5a.819.819 0 01.012-1.175c.338-.338.838-.338 1.163 0l2.5 2.5c.337.337.337.837 0 1.162a.743.743 0 01-.588.263z"></path>
    </svg>
  );
};
export const SidebarRightIcon = ({
  height = 24,
  width = 24,
  color = "#346fef",
  size = 24
}) => {
  return (
    <svg
      class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-vubbuv"
      focusable="false"
      aria-hidden="true"
      viewBox="0 0 24 24"
      color={color}
      height={height}
      width={width}
      fill={color}
      style={{ fontSize: size || height}}
    >
      <path d="M5.641 21.745h13.325c1.838 0 3.338-1.5 3.338-3.337V5.083c0-1.838-1.5-3.338-3.338-3.338H5.63c-1.825 0-3.325 1.5-3.325 3.338V18.42c0 1.825 1.5 3.325 3.337 3.325zM18.966 3.408c.913 0 1.663.75 1.663 1.662v13.338a1.67 1.67 0 01-1.663 1.662H5.63a1.67 1.67 0 01-1.663-1.662V5.083c0-.913.75-1.663 1.663-1.663h13.337v-.012zm-3.325 18.337c.5 0 .838-.337.838-.837V2.583c-.013-.5-.338-.838-.838-.838-.5 0-.837.338-.837.838V20.92c0 .488.337.825.837.825zm-5-9.162c.25 0 .413-.088.588-.25a.819.819 0 00-.013-1.175l-2.5-2.5c-.337-.338-.837-.338-1.162 0-.338.337-.338.837 0 1.162l2.5 2.5a.743.743 0 00.587.263zm-2.5 2.5c.25 0 .413-.088.588-.25l2.5-2.5a.819.819 0 00-.013-1.175c-.337-.338-.837-.338-1.162 0l-2.5 2.5c-.338.337-.338.837 0 1.162a.743.743 0 00.587.263z"></path>
    </svg>
  );
};
export const FolderFilledIcon = ({ height = 24, width = 24, color = "#346fef", size = 24 }) => {
  return (
    <svg
      class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-1t8mnmp"
      focusable="false"
      aria-hidden="true"
      viewBox="0 0 24 24"
      color={color}
      height={height}
      width={width}
      fill={color}
      style={{ fontSize: size || height}}
    >
      <path d="M10 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6H12L10 4Z"></path>
    </svg>
  );
};
export const WebsiteIcon = ({ height = 24, width = 24, color = "#346fef", size = 24 }) => {
  return (
    <svg
      class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-1t8mnmp"
      focusable="false"
      aria-hidden="true"
      viewBox="0 0 24 24"
      color={color}
      height={height}
      width={width}
      fill={color}
      style={{ fontSize: size || height}}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.82611 3.82611C5.08997 2.56225 6.96124 2.10001 9.30001 2.10001H14.7C17.0388 2.10001 18.91 2.56225 20.1739 3.82611C21.4378 5.08997 21.9 6.96124 21.9 9.30001V12C21.9 12.4971 21.4971 12.9 21 12.9C20.5029 12.9 20.1 12.4971 20.1 12V9.30001C20.1 7.13877 19.6622 5.86004 18.9011 5.0989C18.14 4.33776 16.8612 3.90001 14.7 3.90001H9.30001C7.13877 3.90001 5.86004 4.33776 5.0989 5.0989C4.33776 5.86004 3.90001 7.13877 3.90001 9.30001V14.7C3.90001 16.8612 4.33776 18.14 5.0989 18.9011C5.86004 19.6622 7.13877 20.1 9.30001 20.1H12C12.4971 20.1 12.9 20.5029 12.9 21C12.9 21.4971 12.4971 21.9 12 21.9H9.30001C6.96124 21.9 5.08997 21.4378 3.82611 20.1739C2.56225 18.91 2.10001 17.0388 2.10001 14.7V9.30001C2.10001 6.96124 2.56225 5.08997 3.82611 3.82611Z"
      ></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.9224 14.4967L15.5675 19.7786C15.7018 20.2072 16.2882 20.2031 16.4266 19.7888L16.4276 19.7856L16.9158 18.3414C17.1417 17.6552 17.6787 17.1396 18.338 16.9196L18.3398 16.919L19.7885 16.431C20.2123 16.289 20.1954 15.6961 19.7884 15.5673L19.7873 15.5669L14.4866 13.9244L14.4821 13.923C14.1498 13.8181 13.8101 14.1249 13.9224 14.4967ZM15.0214 12.2057C13.2728 11.6558 11.6749 13.3015 12.2015 15.0245L13.8492 20.3148C14.498 22.3904 17.4341 22.4495 18.1333 20.3607L18.1339 20.3588L18.6223 18.914L18.6252 18.9053C18.667 18.7773 18.7689 18.6733 18.9081 18.627L20.3605 18.1378C22.4274 17.4446 22.4096 14.5031 20.3261 13.8495L15.0214 12.2057Z"
      ></path>
    </svg>
  );
};
export const MonitorIcon = ({ height = 24, width = 24, color = "#346fef", size = 24 }) => {
  return (
    <svg
      class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-1t8mnmp"
      focusable="false"
      aria-hidden="true"
      viewBox="0 0 24 24"
      color={color}
      height={height}
      width={width}
      fill={color}
      style={{ fontSize: size || height}}
    >
      <path
        fill-rule="evenodd"
        d="M21.65 2.15C20.69 1.2 19.22 1 17.45 1H6.34c-1.77 0-3.24.2-4.19 1.15C1.2 3.1 1 4.57 1 6.34v6.6c.02 1.66.25 3.03 1.15 3.93.96.95 2.42 1.14 4.19 1.14H11V21H7.4c-.5 0-.9.4-.9.9s.4.9.9.9h9c.5 0 .9-.4.9-.9s-.4-.9-.9-.9h-3.6v-2.99h4.66c1.77 0 3.23-.2 4.19-1.15.9-.9 1.13-2.27 1.15-3.92v-6.6c0-1.77-.2-3.24-1.15-4.19zM2.8 6.34c0-1.78.24-2.53.63-2.91.38-.39 1.13-.63 2.91-.63h11.11c1.79 0 2.54.25 2.92.63.39.38.63 1.13.63 2.91V12H2.8V6.34zm17.58 9.25c-.38.38-1.14.62-2.92.62H6.34c-1.78.01-2.54-.24-2.92-.62-.28-.29-.49-.79-.58-1.79h18.12c-.09 1-.3 1.5-.58 1.79z"
        clip-rule="evenodd"
      ></path>
    </svg>
  );
};
export const MailIcon = ({ height = 24, width = 24, color = "#346fef", size = 24 }) => {
  return (
    <svg
      class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-1t8mnmp"
      focusable="false"
      aria-hidden="true"
      viewBox="0 0 24 24"
      color={color}
      height={height}
      width={width}
      fill={color}
      style={{ fontSize: size || height}}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.88741 5.74701C3.24646 6.34218 2.8 7.32154 2.8 8.9V15.9C2.8 17.4785 3.24646 18.4578 3.88741 19.053C4.54042 19.6594 5.53796 20 6.9 20H16.9C18.262 20 19.2596 19.6594 19.9126 19.053C20.5535 18.4578 21 17.4785 21 15.9V8.9C21 7.32154 20.5535 6.34218 19.9126 5.74701C19.2596 5.14064 18.262 4.8 16.9 4.8H6.9C5.53796 4.8 4.54042 5.14064 3.88741 5.74701ZM2.66259 4.42799C3.75958 3.40936 5.26204 3 6.9 3H16.9C18.538 3 20.0404 3.40936 21.1374 4.42799C22.2465 5.45782 22.8 6.97846 22.8 8.9V15.9C22.8 17.8215 22.2465 19.3422 21.1374 20.372C20.0404 21.3906 18.538 21.8 16.9 21.8H6.9C5.26204 21.8 3.75958 21.3906 2.66259 20.372C1.55354 19.3422 1 17.8215 1 15.9V8.9C1 6.97846 1.55354 5.45782 2.66259 4.42799Z"
      ></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.6032 8.83832C17.9134 9.2267 17.8501 9.79301 17.4617 10.1032L14.3306 12.6041C12.9725 13.6853 10.8175 13.6853 9.45944 12.6041L9.45722 12.6023L6.33723 10.1023C5.94933 9.79153 5.88685 9.22512 6.19766 8.83723C6.50847 8.44933 7.07488 8.38685 7.46277 8.69766L10.5815 11.1967C11.2834 11.7546 12.5072 11.7544 13.2089 11.1963L16.3383 8.69678C16.7267 8.38657 17.293 8.44994 17.6032 8.83832Z"
      ></path>
    </svg>
  );
};

export const FilterIcon = ({ height = 24, width = 24, color = "#346fef", size = 24 }) => {
  return (
    <svg
      class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-1t8mnmp"
      focusable="false"
      aria-hidden="true"
      viewBox="0 0 24 24"
      color={color}
      height={height}
      width={width}
      fill={color}
      style={{ fontSize: size || height}}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.9161 1.2H5.4C3.77443 1.2 2.5 2.53194 2.5 4.2V6.5C2.5 6.97188 2.64909 7.47699 2.84124 7.90565C3.0352 8.33833 3.3135 8.78341 3.65474 9.1275L7.41826 13.0891C7.54903 13.2596 7.69763 13.5174 7.81437 13.8092C7.93936 14.1217 8 14.4037 8 14.6V19.9C8 22.2572 10.6179 23.5073 12.4717 22.3665L12.4867 22.3571L13.8768 21.4634C14.3105 21.1984 14.6298 20.7742 14.836 20.3777C15.0472 19.9715 15.2 19.479 15.2 19V14.7C15.2 14.4384 15.2683 14.1078 15.4035 13.789C15.5404 13.4663 15.7165 13.2245 15.8762 13.0914C15.8829 13.0858 15.8895 13.0802 15.896 13.0744L20.196 9.27439C20.2098 9.26214 20.2233 9.24947 20.2364 9.23639C20.579 8.89374 20.8854 8.42217 21.1068 7.93492C21.3272 7.45009 21.5 6.86982 21.5 6.3V4.1C21.5 2.50294 20.1971 1.2 18.6 1.2H10.9456C10.9358 1.19983 10.9259 1.19983 10.9161 1.2ZM9.30748 3H5.4C4.82557 3 4.3 3.46805 4.3 4.2V6.5C4.3 6.62811 4.35091 6.873 4.48376 7.16935C4.61312 7.45792 4.78169 7.70889 4.9364 7.8636L4.9525 7.88012L5.74286 8.71208L9.30748 3ZM7.02341 10.06L11.4292 3H18.6C19.2029 3 19.7 3.49705 19.7 4.1V6.3C19.7 6.53017 19.6228 6.8499 19.4682 7.19007C19.3201 7.51585 19.1346 7.78643 18.9805 7.94641L14.7128 11.7178C14.2781 12.084 13.9578 12.5879 13.7465 13.086C13.5317 13.5922 13.4 14.1616 13.4 14.7V19C13.4 19.121 13.3528 19.3285 13.239 19.5473C13.1224 19.7716 12.9962 19.8927 12.937 19.9283C12.929 19.933 12.9211 19.9379 12.9133 19.9429L11.5218 20.8375C10.7765 21.2895 9.8 20.7403 9.8 19.9V14.6C9.8 14.0963 9.66064 13.5783 9.48563 13.1407C9.30868 12.6984 9.06713 12.2682 8.80278 11.9378C8.78685 11.9178 8.77007 11.8986 8.7525 11.8801L7.02341 10.06Z"
      ></path>
    </svg>
  );
};

export const DollarIcon = ({ height = 24, width = 24, color = "#346fef", size = 24 }) => {
  return (
    <svg
      class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-1t8mnmp"
      focusable="false"
      aria-hidden="true"
      viewBox="0 0 24 24"
      color={color}
      height={height}
      width={width}
      fill={color}
      style={{ fontSize: size || height}}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 5.10001C12.497 5.10001 12.9 5.50295 12.9 6.00001V6.44001H13.122C14.8898 6.44001 16.242 7.9247 16.242 9.67001C16.242 10.1671 15.839 10.57 15.342 10.57C14.8449 10.57 14.442 10.1671 14.442 9.67001C14.442 8.83531 13.8142 8.24001 13.122 8.24001H12.9V11.3575L14.3226 11.8517C14.7826 12.0147 15.3011 12.2655 15.6865 12.7573C16.0803 13.2596 16.242 13.8912 16.242 14.63C16.242 16.2083 15.007 17.56 13.402 17.56H12.9V18C12.9 18.4971 12.497 18.9 12 18.9C11.5029 18.9 11.1 18.4971 11.1 18V17.56H10.892C9.12417 17.56 7.77198 16.0753 7.77198 14.33C7.77198 13.8329 8.17492 13.43 8.67198 13.43C9.16903 13.43 9.57198 13.8329 9.57198 14.33C9.57198 15.1647 10.1998 15.76 10.892 15.76H11.1V12.6377L9.69131 12.1483C9.23134 11.9853 8.71287 11.7345 8.32741 11.2427C7.93361 10.7404 7.77198 10.1088 7.77198 9.37001C7.77198 7.79174 9.007 6.44001 10.612 6.44001H11.1V6.00001C11.1 5.50295 11.5029 5.10001 12 5.10001ZM11.1 8.24001H10.612C10.077 8.24001 9.57198 8.70827 9.57198 9.37001C9.57198 9.85122 9.67534 10.0446 9.74404 10.1323C9.82089 10.2303 9.96189 10.3342 10.2901 10.4508L11.1 10.7322V8.24001ZM12.9 13.263V15.76H13.402C13.937 15.76 14.442 15.2917 14.442 14.63C14.442 14.1488 14.3386 13.9554 14.2699 13.8677C14.1931 13.7697 14.0521 13.6658 13.7238 13.5492L12.9 13.263Z"
      ></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.09998 12C1.09998 5.97995 5.97992 1.10001 12 1.10001C18.02 1.10001 22.9 5.97995 22.9 12C22.9 18.0201 18.02 22.9 12 22.9C5.97992 22.9 1.09998 18.0201 1.09998 12ZM12 2.90001C6.97403 2.90001 2.89998 6.97406 2.89998 12C2.89998 17.0259 6.97403 21.1 12 21.1C17.0259 21.1 21.1 17.0259 21.1 12C21.1 6.97406 17.0259 2.90001 12 2.90001Z"
      ></path>
    </svg>
  );
};
export const StarIcon = ({
  height = 24,
  width = 24,
  color = "#346fef",
  size = 24
}) => {
  return (
    <svg
      class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-1t8mnmp"
      focusable="false"
      aria-hidden="true"
      viewBox="0 0 24 24"
      color={color}
      height={height}
      width={width}
      fill={color}
      style={{ fontSize: size || height}}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.0641 3.91417C11.0641 3.91436 11.0642 3.91399 11.0641 3.91417L9.30641 7.42965C9.10561 7.83756 8.77417 8.18002 8.4398 8.42795C8.1043 8.67671 7.68221 8.89232 7.24068 8.9673L7.23751 8.96783L4.04796 9.49775C4.04781 9.49778 4.04811 9.49773 4.04796 9.49775C3.18446 9.64177 2.96219 9.97118 2.91985 10.1038C2.87723 10.2372 2.86801 10.6352 3.4864 11.2536L5.9664 13.7336C6.31127 14.0785 6.53755 14.5343 6.6615 14.9673C6.78557 15.4007 6.83398 15.905 6.72822 16.3768L6.72688 16.3828L6.01686 19.4528C5.75555 20.582 6.0395 20.914 6.098 20.9567C6.15719 20.9999 6.56163 21.1689 7.56069 20.576L10.5574 18.8021C11.0015 18.5436 11.5272 18.44 12.0038 18.44C12.4793 18.44 13.0058 18.5433 13.4485 18.8055C13.4484 18.8055 13.4486 18.8056 13.4485 18.8055L16.4377 20.5751C16.4376 20.575 16.4379 20.5752 16.4377 20.5751C17.4458 21.1705 17.8495 21.0015 17.9061 20.9602C17.9611 20.9202 18.2455 20.5912 17.983 19.4523C17.983 19.4522 17.983 19.4523 17.983 19.4523L17.2718 16.3768C17.166 15.905 17.2144 15.4007 17.3385 14.9673C17.4625 14.5343 17.6887 14.0785 18.0336 13.7336L20.5136 11.2536L20.5158 11.2514C21.1382 10.6332 21.1266 10.2367 21.0844 10.1054C21.0416 9.97207 20.8169 9.642 19.9525 9.49783C19.9523 9.4978 19.9526 9.49785 19.9525 9.49783L16.7625 8.96783C16.3169 8.89356 15.8915 8.67887 15.5531 8.42919C15.2164 8.18069 14.8845 7.83782 14.6836 7.42962L12.925 3.91249L12.9242 3.9108C12.5142 3.08658 12.1266 2.9775 11.9988 2.9775C11.8694 2.9775 11.479 3.08907 11.0641 3.91417ZM14.5354 3.10834C13.9953 2.02297 13.1282 1.1775 11.9988 1.1775C10.8707 1.1775 10.0009 2.02142 9.45586 3.10582L9.45502 3.10751L7.69502 6.62751L7.69175 6.63412C7.65236 6.71454 7.54481 6.85074 7.36771 6.98205C7.19142 7.11276 7.02911 7.17716 6.9404 7.19252C6.94004 7.19258 6.93969 7.19264 6.93933 7.1927L3.7525 7.72217C2.57637 7.91819 1.54281 8.49883 1.20516 9.55622C0.867776 10.6128 1.372 11.6848 2.21361 12.5264L4.69361 15.0064C4.76874 15.0815 4.86746 15.2407 4.93101 15.4627C4.99402 15.6828 4.99601 15.8725 4.97227 15.981C4.97211 15.9817 4.97195 15.9824 4.97179 15.9832L4.26318 19.0471C4.26317 19.0471 4.26318 19.0471 4.26318 19.0471C3.96452 20.3378 4.05053 21.691 5.03701 22.4108C6.02257 23.1299 7.33773 22.8012 8.47847 22.1245M8.47847 22.1245L11.4626 20.3579C11.4633 20.3575 11.4641 20.3571 11.4648 20.3567C11.5711 20.2956 11.7644 20.24 12.0038 20.24C12.2455 20.24 12.4339 20.2966 12.5312 20.3543L15.5215 22.1245C16.6631 22.7988 17.9805 23.1335 18.9664 22.4148C19.954 21.6948 20.0345 20.3388 19.737 19.0479L19.0282 15.9832C19.028 15.9824 19.0279 15.9817 19.0277 15.9809C19.004 15.8724 19.006 15.6828 19.069 15.4627C19.1325 15.2407 19.2313 15.0815 19.3064 15.0064L21.7842 12.5286C21.7847 12.5281 21.7851 12.5277 21.7856 12.5272C22.6323 11.6856 23.1382 10.6127 22.7981 9.55459C22.4584 8.49794 21.4232 7.91811 20.248 7.72224L17.058 7.19224C16.9635 7.17638 16.7982 7.11092 16.6219 6.9808C16.4447 6.85007 16.3375 6.71427 16.2983 6.63412L14.5354 3.10834C14.5353 3.10805 14.5355 3.10862 14.5354 3.10834"
      ></path>
    </svg>
  );
};

export const LockIcon = ({ height = 24, width = 24, color = "#346fef", size = 24 }) => {
  return (
    <svg
      class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-1t8mnmp"
      focusable="false"
      aria-hidden="true"
      viewBox="0 0 24 24"
      color={color}
      height={height}
      width={width}
      fill={color}
      style={{ fontSize: size || height}}
    >
      <path
        fill-rule="evenodd"
        d="M7.826 4.323C7.15 5.162 6.9 6.4 6.9 8v2a.9.9 0 11-1.8 0V8c0-1.709.25-3.472 1.324-4.806C7.532 1.818 9.346 1.1 12 1.1c2.654 0 4.468.718 5.576 2.094C18.65 4.528 18.9 6.291 18.9 8v2a.9.9 0 11-1.8 0V8c0-1.601-.25-2.838-.926-3.677C15.533 3.527 14.346 2.9 12 2.9s-3.532.627-4.174 1.423zM12 14.4a1.6 1.6 0 100 3.2 1.6 1.6 0 000-3.2zM8.6 16a3.4 3.4 0 116.8 0 3.4 3.4 0 01-6.8 0z"
        clip-rule="evenodd"
      ></path>
      <path
        fill-rule="evenodd"
        d="M3.636 11.636C3.173 12.1 2.9 12.994 2.9 15v2c0 2.006.273 2.9.736 3.364.464.463 1.358.736 3.364.736h10c2.006 0 2.9-.273 3.364-.736.463-.464.736-1.358.736-3.364v-2c0-2.006-.273-2.9-.736-3.364-.464-.463-1.358-.736-3.364-.736H7c-2.006 0-2.9.273-3.364.736zm-1.272-1.272C3.4 9.327 5.006 9.1 7 9.1h10c1.994 0 3.6.227 4.636 1.264C22.673 11.4 22.9 13.006 22.9 15v2c0 1.994-.227 3.6-1.264 4.636C20.6 22.673 18.994 22.9 17 22.9H7c-1.994 0-3.6-.227-4.636-1.264C1.327 20.6 1.1 18.994 1.1 17v-2c0-1.994.227-3.6 1.264-4.636z"
        clip-rule="evenodd"
      ></path>
    </svg>
  );
};

export const RadioIcon = ({ height = 24, width = 24, color = "#346fef", size = 24 }) => {
  return (
    <svg
      class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-1t8mnmp"
      focusable="false"
      aria-hidden="true"
      viewBox="0 0 24 24"
      color={color}
      height={height}
      width={width}
      fill={color}
      style={{ fontSize: size || height}}
    >
      <path
        fill-rule="evenodd"
        d="M2.739 5.739C3.805 4.672 5.295 4.1 7 4.1h10c1.704 0 3.195.572 4.261 1.639C22.328 6.805 22.9 8.296 22.9 10v7c0 1.705-.572 3.195-1.639 4.262C20.195 22.328 18.705 22.9 17 22.9H7c-1.705 0-3.195-.572-4.261-1.638C1.672 20.195 1.1 18.705 1.1 17v-7c0-1.704.572-3.195 1.639-4.261zM4.01 7.01c-.683.684-1.111 1.694-1.111 2.99v7c0 1.295.428 2.304 1.111 2.988C4.695 20.672 5.705 21.1 7 21.1h10c1.296 0 2.305-.428 2.989-1.111.683-.684 1.111-1.693 1.111-2.989v-7c0-1.295-.428-2.305-1.111-2.989-.684-.683-1.694-1.11-2.989-1.11H7c-1.295 0-2.305.427-2.989 1.11z"
        clip-rule="evenodd"
      ></path>
      <path
        fill-rule="evenodd"
        d="M7 1.1a.9.9 0 01.9.9v3a.9.9 0 01-1.8 0V2a.9.9 0 01.9-.9zM8.5 11.9a1.6 1.6 0 100 3.2 1.6 1.6 0 000-3.2zm-3.4 1.6a3.4 3.4 0 116.8 0 3.4 3.4 0 01-6.8 0zM13.6 11a.9.9 0 01.9-.9h4a.9.9 0 110 1.8h-4a.9.9 0 01-.9-.9zM13.6 15a.9.9 0 01.9-.9h.5a.9.9 0 110 1.8h-.5a.9.9 0 01-.9-.9zM17.1 15a.9.9 0 01.9-.9h.5a.9.9 0 110 1.8H18a.9.9 0 01-.9-.9z"
        clip-rule="evenodd"
      ></path>
    </svg>
  );
};
export const CopyIcon = ({ height = 24, width = 24, color = "#346fef", size = 24 }) => {
  return (
    <svg
      class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-1t8mnmp"
      focusable="false"
      aria-hidden="true"
      viewBox="0 0 24 24"
      color={color}
      height={height}
      width={width}
      fill={color}
      style={{ fontSize: size || height}}
    >
      <path
        fill-rule="evenodd"
        d="M3.825 8.855c-.592.593-.955 1.609-.955 3.395v4.5c0 1.786.363 2.803.955 3.395.593.592 1.609.955 3.395.955h4.5c1.786 0 2.803-.363 3.395-.955.592-.592.955-1.609.955-3.395v-4.5c0-1.786-.363-2.802-.955-3.395-.592-.592-1.609-.955-3.395-.955h-4.5c-1.786 0-2.802.363-3.395.955zM2.552 7.582C3.647 6.487 5.256 6.1 7.22 6.1h4.5c1.964 0 3.572.387 4.668 1.482 1.095 1.096 1.482 2.704 1.482 4.668v4.5c0 1.964-.387 3.573-1.482 4.668-1.096 1.095-2.704 1.482-4.668 1.482h-4.5c-1.964 0-3.573-.387-4.668-1.482-1.095-1.095-1.482-2.704-1.482-4.668v-4.5c0-1.964.387-3.572 1.482-4.668z"
        clip-rule="evenodd"
      ></path>
      <path
        fill-rule="evenodd"
        d="M12.5 3.53c-.367.368-.63 1.034-.63 2.32v.25c1.896.02 3.45.415 4.518 1.482 1.067 1.068 1.462 2.622 1.481 4.518h.251c1.286 0 1.953-.263 2.32-.63.367-.367.63-1.034.63-2.32v-3.3c0-1.286-.263-1.952-.63-2.32-.367-.367-1.034-.63-2.32-.63h-3.3c-1.286 0-1.953.263-2.32.63zm-1.273-1.273c.87-.87 2.13-1.157 3.593-1.157h3.3c1.464 0 2.723.287 3.593 1.157.87.87 1.157 2.13 1.157 3.593v3.3c0 1.464-.287 2.723-1.157 3.593-.87.87-2.13 1.157-3.593 1.157h-1.15a.9.9 0 01-.9-.9v-.75c0-1.786-.363-2.802-.955-3.395-.592-.592-1.609-.955-3.395-.955h-.75a.9.9 0 01-.9-.9V5.85c0-1.464.287-2.722 1.157-3.593z"
        clip-rule="evenodd"
      ></path>
    </svg>
  );
};
export const BrushOutlinedIcon = ({ height = 24, width = 24, color = "#346fef", size = 24 }) => {
  return (
    <svg
      class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-1t8mnmp"
      focusable="false"
      aria-hidden="true"
      viewBox="0 0 24 24"
      color={color}
      height={height}
      width={width}
      fill={color}
      style={{ fontSize: size || height}}
    >
      <path
        fill-rule="evenodd"
        d="M20.293 2.95c-1.818.728-4.012 2.032-6.08 3.566-2.073 1.536-3.963 3.26-5.189 4.794v.002L7.8 12.857a5.08 5.08 0 012.066 1.267 4.922 4.922 0 011.232 1.982l1.519-1.218c3.108-2.492 6.875-7.586 8.358-11.283l.003-.01a.459.459 0 00-.133-.547c-.11-.114-.3-.188-.552-.098zM6.066 12.145l1.55-1.957C8.97 8.493 10.99 6.663 13.14 5.07c2.15-1.593 4.486-2.992 6.496-3.795l.02-.007c.92-.343 1.861-.103 2.47.517.604.593.91 1.54.518 2.495-1.599 3.982-5.55 9.326-8.9 12.013l-1.97 1.58c-.013.01-.025.02-.038.028a4.469 4.469 0 01-.977.558.9.9 0 01-1.229-.838 2.839 2.839 0 00-.032-.453c-.083-.635-.368-1.234-.904-1.77s-1.172-.84-1.807-.93l-.133-.008a1.817 1.817 0 00-.294-.003.9.9 0 01-.938-1.197c.145-.408.366-.79.645-1.114z"
        clip-rule="evenodd"
      ></path>
      <path
        fill-rule="evenodd"
        d="M6.797 14.467a4.792 4.792 0 00-.498-.007c-1.537.031-2.949 1.134-3.134 2.828l-.271 2.467a1.214 1.214 0 001.336 1.35l2.452-.268c.796-.107 1.438-.44 1.9-.901a3.27 3.27 0 00.935-2.592l-.014-.209c-.088-.623-.372-1.211-.9-1.739l-.004-.004a3.128 3.128 0 00-1.802-.925zm-.549-1.806a6.914 6.914 0 01.747.016 4.925 4.925 0 012.884 1.449c.802.803 1.277 1.763 1.413 2.807a.9.9 0 01.007.07l.008.129a5.07 5.07 0 01-1.447 4.07l-.004.004c-.756.756-1.77 1.262-2.949 1.416l-.019.003-2.458.27a3.015 3.015 0 01-3.324-3.346l.27-2.457c.293-2.681 2.534-4.377 4.872-4.431zM8.61 9.74a.9.9 0 01.9-.9 5.633 5.633 0 015.63 5.63.9.9 0 01-1.8 0 3.833 3.833 0 00-3.83-3.83.9.9 0 01-.9-.9z"
        clip-rule="evenodd"
      ></path>
    </svg>
  );
};

export const GoalsStarIcon = ({
  height = 24,
  width = 24,
  color = "#3E50F7",
  className = "",
  style = {},
}) => {
  return (
    <svg
      height={height}
      width={width}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M13.7276 3.44418L15.4874 6.99288C15.7274 7.48687 16.3673 7.9607 16.9073 8.05143L20.0969 8.58575C22.1367 8.92853 22.6167 10.4206 21.1468 11.8925L18.6671 14.3927C18.2471 14.8161 18.0172 15.6327 18.1471 16.2175L18.8571 19.3125C19.417 21.7623 18.1271 22.71 15.9774 21.4296L12.9877 19.6452C12.4478 19.3226 11.5579 19.3226 11.0079 19.6452L8.01827 21.4296C5.8785 22.71 4.57865 21.7522 5.13859 19.3125L5.84851 16.2175C5.97849 15.6327 5.74852 14.8161 5.32856 14.3927L2.84884 11.8925C1.389 10.4206 1.85895 8.92853 3.89872 8.58575L7.08837 8.05143C7.61831 7.9607 8.25824 7.48687 8.49821 6.99288L10.258 3.44418C11.2179 1.51861 12.7777 1.51861 13.7276 3.44418Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const TargetIcon = ({
  height = 24,
  width = 24,
  color = "#0B703B",
  className = "",
  style = {},
}) => {
  return (
    <svg
      height={height}
      width={width}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 11.0576 20.8555 10.1508 20.5881 9.29965C20.4227 8.77274 20.7156 8.21144 21.2425 8.04595C21.7695 7.88046 22.3308 8.17344 22.4962 8.70035C22.8238 9.74323 23 10.852 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C13.2012 1 14.3594 1.19291 15.444 1.5502C15.9686 1.723 16.2537 2.28831 16.081 2.81287C15.9082 3.33743 15.3428 3.62259 14.8183 3.4498C13.933 3.15818 12.986 3 12 3Z"
        fill={color}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12C16 11.4477 16.4477 11 17 11C17.5523 11 18 11.4477 18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12C6 8.68629 8.68629 6 12 6C12.5523 6 13 6.44772 13 7C13 7.55228 12.5523 8 12 8Z"
        fill={color}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19 1C19.5523 1 20 1.44772 20 2V4H22C22.5523 4 23 4.44772 23 5C23 5.55228 22.5523 6 22 6H19.4142L12.7071 12.7071C12.3166 13.0976 11.6834 13.0976 11.2929 12.7071C10.9024 12.3166 10.9024 11.6834 11.2929 11.2929L18 4.58579V2C18 1.44772 18.4477 1 19 1Z"
        fill={color}
      />
    </svg>
  );
};
export const AchievedIcon = ({
  height = 24,
  width = 24,
  color = "#3C568D",
  className = "",
  style = {},
}) => {
  return (
    <svg
      height={height}
      width={width}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M8.62224 9.51493L7.8116 12.7575C7.65382 13.3886 8.13118 14 8.78175 14H15.2202C15.8708 14 16.3482 13.3886 16.1904 12.7575L15.3797 9.51493C15.1571 8.62459 14.3572 8 13.4394 8H10.5626C9.64479 8 8.84482 8.62459 8.62224 9.51493Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.12224 17.5149L2.3116 20.7575C2.15382 21.3886 2.63118 22 3.28175 22H9.72019C10.3708 22 10.8482 21.3886 10.6904 20.7575L9.8797 17.5149C9.65712 16.6246 8.85715 16 7.93942 16H5.06252C4.14479 16 3.34482 16.6246 3.12224 17.5149Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.1203 17.5149L13.3096 20.7575C13.1518 21.3886 13.6292 22 14.2798 22H20.7182C21.3688 22 21.8462 21.3886 21.6884 20.7575L20.8777 17.5149C20.6551 16.6246 19.8552 16 18.9374 16H16.0606C15.1428 16 14.3429 16.6246 14.1203 17.5149Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 2V4M7.5 3.5L9 5M16.5 3.5L15 5"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
  );
};
export const TrophyIcon = ({
  height = 24,
  width = 24,
  color = "#FFA488",
  className = "",
  style = {},
}) => {
  return (
    <svg
      height={height}
      width={width}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M12 17C9.79086 17 8 19.2386 8 22H16C16 19.2386 14.2091 17 12 17Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.5 5H22L21.7616 6.66896C21.4984 8.51101 21.3669 9.43204 21.001 10.2267C20.6067 11.0831 20.0161 11.8345 19.2772 12.4201C18.5915 12.9634 17.7277 13.3089 16 14"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.5 5H2L2.23842 6.66896C2.50157 8.51101 2.63315 9.43204 2.99902 10.2267C3.39331 11.0831 3.98387 11.8345 4.72282 12.4201C5.4085 12.9634 6.27233 13.3089 8 14"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.9998 17C8.55573 17 5.73726 10.8185 5.51407 3.00094C5.49831 2.44888 5.94755 2 6.49983 2H17.4998C18.0521 2 18.5013 2.44888 18.4856 3.00093C18.2624 10.8185 15.4439 17 11.9998 17Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const PercentArrowDownIcon = ({
  height = 20,
  width = 20,
  color = "#F95959",
  className = "",
  style = {},
}) => {
  return (
    <svg
      height={height}
      width={width}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.02032 14.9809C5.2994 15.26 5.68207 15.4104 6.00023 15.5033C6.34307 15.6033 6.73924 15.6716 7.14924 15.7194C7.9714 15.8154 8.94474 15.84 9.8599 15.8328C10.7802 15.8256 11.6649 15.786 12.318 15.7485C12.6451 15.7296 13.4039 15.6745 13.4039 15.6745C13.8626 15.6358 14.203 15.2327 14.1643 14.7741C14.1257 14.3155 13.7218 13.9751 13.2633 14.0137C13.2633 14.0137 12.5398 14.0663 12.2223 14.0845C11.5861 14.1212 10.7306 14.1593 9.8469 14.1662C8.95824 14.1732 8.06407 14.1482 7.34249 14.064C7.27298 14.0559 7.20598 14.0473 7.14149 14.0383L15.5899 5.5899C15.9153 5.26448 15.9153 4.73682 15.5899 4.4114C15.2645 4.08598 14.7368 4.08598 14.4114 4.4114L5.9629 12.8599C5.9539 12.7953 5.94532 12.7283 5.93723 12.6587C5.85298 11.9372 5.82807 11.0431 5.83507 10.1544C5.84199 9.27065 5.88015 8.41523 5.91673 7.77898C5.93507 7.4614 5.98765 6.73723 5.98765 6.73723C6.02623 6.27865 5.68582 5.87557 5.22723 5.8369C4.76865 5.79823 4.36549 6.13923 4.32682 6.5979C4.32682 6.5979 4.27165 7.35615 4.25282 7.68323C4.21524 8.33632 4.17565 9.22107 4.1684 10.1413C4.16124 11.0565 4.18582 12.0298 4.28182 12.852C4.32965 13.262 4.3979 13.6582 4.49798 14.001C4.59082 14.3192 4.74123 14.7018 5.02032 14.9809Z"
        fill={color}
      />
    </svg>
  );
};

export const searchIcon = ({ width = 20, height = 21 }) => {
    return (
      <svg
        width={width}
        height={height}
        viewBox="0 -1 20 20"
        fill="#9ea0a8"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.0252 14.3469L18.5943 17.9152L17.4152 19.0943L13.8469 15.5252C12.5191 16.5895 10.8677 17.1684 9.16602 17.166C5.02602 17.166 1.66602 13.806 1.66602 9.66602C1.66602 5.52602 5.02602 2.16602 9.16602 2.16602C13.306 2.16602 16.666 5.52602 16.666 9.66602C16.6684 11.3677 16.0895 13.0191 15.0252 14.3469ZM13.3535 13.7285C14.4111 12.6409 15.0017 11.183 14.9993 9.66602C14.9993 6.44268 12.3885 3.83268 9.16602 3.83268C5.94268 3.83268 3.33268 6.44268 3.33268 9.66602C3.33268 12.8885 5.94268 15.4993 9.16602 15.4993C10.683 15.5017 12.1409 14.9111 13.2285 13.8535L13.3535 13.7285Z"
          fill={0.4}
          fillOpacity="#0D1126"
        />
      </svg>
    );
  };

export const PlusIcon = ({ width = 20, height = 20, fill = "#000000", ...props }) => {
  return (
    <svg
      width={`${width}px`}
      height={`${height}px`}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.5 3C13.5 2.44772 13.0523 2 12.5 2H11.5C10.9477 2 10.5 2.44772 10.5 3V10.5H3C2.44772 10.5 2 10.9477 2 11.5V12.5C2 13.0523 2.44772 13.5 3 13.5H10.5V21C10.5 21.5523 10.9477 22 11.5 22H12.5C13.0523 22 13.5 21.5523 13.5 21V13.5H21C21.5523 13.5 22 13.0523 22 12.5V11.5C22 10.9477 21.5523 10.5 21 10.5H13.5V3Z"
        fill={fill}
      />
    </svg>
  );
};


